import endOfLifeImage from '../../../../assets/images/end-of-life.png';
import styles from './ProductEndOfLife.module.css';

export default function ProductEndOfLifeContent() {
  return (
    <div className={styles.content}>
      <img
        className={styles.image}
        src={endOfLifeImage}
        alt="End of life sunset illustration"
      />
      <h1 className={styles.title}>This product has reached its end of life.</h1>
      <p className={styles.description}>
        Thank you for using this product. If you have any questions or need assistance, please contact the ACA team.
      </p>
    </div>
  );
}
